import { defineComponent as o, openBlock as r, createBlock as i, unref as n, withCtx as l, createElementVNode as a } from "vue";
import c from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as f } from "@storefront-ui/shared";
const u = /* @__PURE__ */ o({
  __name: "SfIconFavorite",
  props: {
    size: {
      type: String,
      default: f.base
    }
  },
  setup(t) {
    return (d, e) => (r(), i(n(c), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "favorite"
    }, {
      default: l(() => e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M19.664 4.99c-2.64-1.8-5.9-.96-7.66 1.1-1.76-2.06-5.02-2.91-7.66-1.1-1.4.96-2.28 2.58-2.34 4.29-.14 3.88 3.3 6.99 8.55 11.76l.1.09c.76.69 1.93.69 2.69-.01l.11-.1c5.25-4.76 8.68-7.87 8.55-11.75-.06-1.7-.94-3.32-2.34-4.28m-7.56 14.56-.1.1-.1-.1c-4.76-4.31-7.9-7.16-7.9-10.05 0-2 1.5-3.5 3.5-3.5 1.54 0 3.04.99 3.57 2.36h1.87c.52-1.37 2.02-2.36 3.56-2.36 2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  u as default
};
